var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"title"},[_vm._v("我是记分长后台管理系统")])])])}]

export { render, staticRenderFns }